import React, { useRef, useState, memo } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Footer from '../../layout/Footer';
import Loader from '../common/Loader';
import { createNotification } from '../helpers/Notification';
import { getApiUrl } from '../helpers/Util';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../hooks/useAPI';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loader, setLoader] = useState(false);
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const navigate = useNavigate();
  const { execute } = useAPI();

  const triggerUpdate = () => forceUpdate(n => n + 1);

  const handleOnChange = (event) => {
    setEmail(event.target.value);
  };

  const handleResetState = () => {
    setEmail('');
  };

  const handleOnResetClick = async () => {
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      triggerUpdate();
      return;
    }
    try {
      setLoader(true);
      const URL = getApiUrl();
      const url = `${URL}/forgot-password`;
      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      };

      const data = { email };
      const response = await axios.post(url, data, {headers,});
      // Success
      if (response.status === 200) {
        createNotification(
          'success',
          response?.data?.message || 'Reset link sent successfully!'
        );
        handleResetState();
      }
      console.log({ response });
    } catch (error) {
      console.log({ resetPasswordError: error,});
      const status = error?.response?.status;
      // Error Handling
      if (status === 404 || status === 401) {
        createNotification('error', 'This email ID is not registered!');
      } else if (status === 500) {
        createNotification('error', 'Internal server error!');
      } else {
        createNotification('error', 'Something went wrong!');
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <>
          <main className="user-account-page">
            <div className="container-fluid">
              <section className="form-container">
                <div className="row">
                  <div className="col-md-6 logo-col">
                    <div className="logo-content-frame">
                      <h1 className="logo-frame">
                        <span className="logo"></span>
                      </h1>
                      <h2 className="title">Welcome, User</h2>
                      <label className="lbl">Forgot Password?</label>
                    </div>
                  </div>
                  <div className="col-md-6 form-col">
                    <div className="content-frame">
                      <h2 className="title">Forgot Password</h2>

                      <section className="form-frame login-form">
                        <div className="form-group">
                          <input
                            type="text"
                            name="email"
                            placeholder="Email"
                            value={email}
                            onChange={handleOnChange}
                            className="form-control"
                          />
                          {validator.current.message('email', email, 'required|email', { className: 'text-danger' })}
                        </div>

                        <div className="btn-row">
                          <input
                            type="button"
                            name="signIn"
                            value="Reset My Password"
                            className="btn-rnd-black btn-signIn"
                            onClick={handleOnResetClick}
                          />
                          <input
                            type="button"
                            name="signIn"
                            value="Back to Signin"
                            className="btn-rnd-black btn-signIn mt-3"
                            onClick={() => {
                              navigate('/login');
                            }}
                          />
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default memo(ForgotPassword);